"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.zeroPadding = void 0;
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var zeroPadding = function zeroPadding(num, length) {
  var numString = String(num);

  while (numString.length < length) {
    numString = "0" + numString;
  }

  return numString;
};

exports.zeroPadding = zeroPadding;